import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Sustainability from "./Pages/Sustainability";
import Navbar from "./components/Navbar";
import Contact from "./Pages/Contact";
import Content from "./Pages/Content";
import Search from "./Pages/Search";
import Corporate from "./Pages/Corporate";
import Career from "./Pages/Career";
import Activities from "./Pages/Activities";
import Publications from "./Pages/Publications";
import MediaCenter from "./Pages/MediaCenter";
import Footer from "./components/Footer";
import OnlineServices from "./Pages/OnlineServices";
import OnlineServicesEn from "./Pages/OnlineServicesEn"

import HomePageEn from "./Pages/HomePageEn";
import ContactEn from "./Pages/ContactEn";

function App() {
  return (
    <main className="main">
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path="/iletisim">
            <Contact />
            <Footer />
          </Route>
          <Route path="/kurumsal">
            <Corporate />
            <Footer />
          </Route>
          <Route path="/surdurulebilirlik">
            <Sustainability />
            <Footer />
          </Route>
          <Route path="/kariyer">
            <Career />
            <Footer />
          </Route>
          <Route path="/faaliyet-alanlari">
            <Activities />
            <Footer />
          </Route>
          <Route path="/yayinlar">
            <Publications />
            <Footer />
          </Route>
          <Route path="/medya-merkezi">
            <MediaCenter />
            <Footer />
          </Route>
          <Route path="/icerik">
            <Content />
            <Footer />
          </Route>
          <Route path="/arama">
            <Search />
            <Footer />
          </Route>
          <Route path="/online-islemler">
            <OnlineServices />
            <Footer />
          </Route>
          
          <Route path="/en" exact>
            <HomePageEn />            
          </Route>
          <Route path="/en/corporate">
            <Corporate />
            <Footer />
          </Route>
          <Route path="/en/contact">
            <ContactEn />
            <Footer />
          </Route>
          <Route path="/en/activities">
            <Activities />
            <Footer />
          </Route>

          <Route path="/en/sustainability">
            <Sustainability />
            <Footer />
          </Route>
          <Route path="/en/career">
            <Career />
            <Footer />
          </Route>
          <Route path="/en/publications">
            <Publications />
            <Footer />
          </Route>
          <Route path="/en/media-center">
            <MediaCenter />
            <Footer />
          </Route>
          <Route path="/en/content">
            <Content />
            <Footer />
          </Route>
          <Route path="/en/search">
            <Search />
            <Footer />
          </Route>
          <Route path="/en/online-services">
            <OnlineServicesEn />
            <Footer />
          </Route>
          
        </Switch>
      </Router>
    </main>
  );
}

export default App;
